import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import {
  HeroSection,
  CountersSection,
  LeaderSection,
  AboutSection,
  ServicesSection,
  LocationsSection,
  PartnersSection,
  ContactCTA,
} from '@/components/sections'

export function Home() {
  const { t, i18n } = useTranslation('home')

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
      </Helmet>

      <HeroSection />
      <CountersSection />
      <LeaderSection />
      <AboutSection />
      <ServicesSection />
      <LocationsSection />
      <PartnersSection />
      <ContactCTA />
    </>
  )
}
